import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { Drawer, Grid2, Tab } from "@mui/material";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { DrawerHeader } from "../../_components/drawer/header.drawer";
import { ClientFollowUpsManage } from './_components/client-followUpsManage';
import { ClientContactManage } from './_components/client-contactManage';
import { ClientInfoManage } from './_components/client-infoManage';
import { ClientUploadsManage } from './_components/client-uploadsManage';

export const ClientManageDrawer = (params: { isOpen?: boolean, onSave(): void, onClose(): void }) => {

    const { id } = useParams<{ id: string }>();
    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        if (isOpen == false)
            setIsOpen(true);
    }, []);

    const [tab, setTab] = useState('1');

    const handleTabChange = (event: React.SyntheticEvent, newValue: string) => {
        setTab(newValue);
    };

    return (
        <Drawer
            anchor={"right"}
            variant="persistent"
            open={isOpen}
            ModalProps={{
                keepMounted: true
            }}>

            <DrawerHeader name={(!!id) ? "Update Client" : "Create Client"} onClose={params.onClose} />

            <TabContext value={tab}>
                <Grid2 size={{ xs: 12 }} sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <TabList onChange={handleTabChange} aria-label="lab API tabs example">
                        <Tab label="Client" value="1" />
                        {(!!id) && <Tab label="Contacts" value="2" />}
                        {(!!id) && <Tab label="Follow Ups" value="3" />}
                        {(!!id) && <Tab label="Uploads" value="4" />}
                    </TabList>
                </Grid2>

                <Grid2 size={{ xs: 12 }}>

                    <TabPanel value="1" sx={{ p: 0, m: 0 }}>
                        <ClientInfoManage onSave={params.onSave} />
                    </TabPanel>
                    <TabPanel value="2" sx={{ p: 0, m: 0 }}>
                        <ClientContactManage />
                    </TabPanel>
                    <TabPanel value="3" sx={{ p: 0, m: 0 }}>
                        <ClientFollowUpsManage onSave={params.onSave} />
                    </TabPanel>
                    <TabPanel value="4" sx={{ p: 0, m: 0 }}>
                        <ClientUploadsManage />
                    </TabPanel>
                </Grid2>

            </TabContext>
        </Drawer>
    );
};